import { render, staticRenderFns } from "./AchievementsTag.vue?vue&type=template&id=7a580a96&scoped=true&"
import script from "./AchievementsTag.vue?vue&type=script&lang=js&"
export * from "./AchievementsTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a580a96",
  null
  
)

export default component.exports